import { ComplianceRule } from 'dashboard/models/compliance-rule';
import {
  ComplianceRulesActions,
  ComplianceRulesActionType,
} from 'dashboard/redux/actions/compliance-rules';

export interface ComplianceRulesState {
  complianceRules: ComplianceRule[];
}

export const initialState: ComplianceRulesState = {
  complianceRules: [],
};

const complianceRulesReducer = (
  state: ComplianceRulesState = initialState,
  action: ComplianceRulesActions,
): ComplianceRulesState => {
  switch (action.type) {
    case ComplianceRulesActionType.SetComplianceRules: {
      return {
        ...state,
        complianceRules: action.payload.complianceRules,
      };
    }

    default:
      return state;
  }
};

export default complianceRulesReducer;
